import { useFadeInOnScroll } from '../../animations/useFadeInOnScroll';

/** Thin wrapper so marketing sections fade/slide in on scroll without repeating the hook boilerplate everywhere. */
export default function FadeInSection({ as: Tag = 'div', className, delay = 0, children, ...props }) {
  const ref = useFadeInOnScroll({ delay });
  return (
    <Tag ref={ref} className={className} {...props}>
      {children}
    </Tag>
  );
}
